import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


function PortabilityFpsTable({ month, year, afsoCode, distCode, onDataLoaded }) {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [totals, setTotals] = useState({});
    const [renderContent, setRenderContent] = useState(null);
    const currentTableRef = useRef(null);


    useEffect(() => {
        if (!month || !year || !afsoCode) return;

        setLoading(true);
        setRenderContent(null);
        axios.post(`${process.env.REACT_APP_URL_SIDE}/EkycUpdated/FPS`, {
            month: month,
            year: year,
            distCode: distCode,
            afsoCode
        })
            .then(response => {
                setTitle(response.data.title || "FPS Report");
                setData(response.data.data || []);
                if (onDataLoaded) onDataLoaded();
                setMessage(response.data.message || "");
                calculateTotals(response.data.data || []);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching FPS data:", error);
                setData([]);
                setMessage("Internal  error");
                setLoading(false);
            });



    }, [month, year, afsoCode]);

    const calculateTotals = (data) => {
        if (!data.length) return setTotals({});
        const totalsObj = data.reduce((totals, row) => {
            Object.entries(row).forEach(([key, value]) => {
                if (key !== "District" && typeof value === "number") {
                    totals[key] = (totals[key] || 0) + value;
                }
            });
            return totals;
        }, {});
        setTotals(totalsObj);
    };
    const allSchemes = data.length > 0
        ? Array.from(new Set([
            ...Object.keys(data[0]?.total || {}),
            ...Object.keys(data[0]?.ekyc || {})
        ]))
        : [];


    const grandTotal = {};
    const grandEkyc = {};

    let grandTotal_cards = 0;
    let grandTotal_units = 0;
    let grandEkyc_cards = 0;
    let grandEkyc_units = 0;

    allSchemes.forEach(scheme => {
        grandTotal[scheme] = { cards: 0, units: 0 };
        grandEkyc[scheme] = { cards: 0, units: 0 };
    });

    data.forEach((dist) => {
        Object.entries(dist.total || {}).forEach(([scheme, values]) => {
            if (grandTotal[scheme]) {
                grandTotal[scheme].cards += Number(values.cards || 0);
                grandTotal[scheme].units += Number(values.units || 0);
            }
        });
        Object.entries(dist.ekyc || {}).forEach(([scheme, values]) => {
            if (grandEkyc[scheme]) {
                grandEkyc[scheme].cards += Number(values.cards || 0);
                grandEkyc[scheme].units += Number(values.units || 0);
            }
        });

        grandTotal_cards += Number(dist.total_cards || 0);
        grandTotal_units += Number(dist.total_units || 0);
        grandEkyc_cards += Number(dist.ekyc_cards || 0);
        grandEkyc_units += Number(dist.ekyc_units || 0);
    });
    



    if (loading) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Box sx={{ display: 'flex' }}>
            <CircularProgress />
        </Box></div>
    }

    return (
        <div>
            <div style={{
                overflowX: 'auto',
                overflowY: 'auto',
                maxHeight: '700px',
                maxWidth: '90%',
                margin: '0 auto'
            }}>
            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Box sx={{ display: 'flex' }}>
                    {CircularProgress}
                </Box></div>
            ) : data.length > 0 ? (
                <div>

                    <table align="center" border={1} ref={currentTableRef} >
                        <thead style={{
                        position: 'sticky',
                        top: 0,
                        background: '#fff',
                        zIndex: 10
                    }}>
                            <tr className="tableheader" ><th colSpan={8 + allSchemes.length * 6}>{title}</th></tr>
                            <tr className="tableheader" >
                                <th rowSpan={3}>Sl.No</th>
                                <th rowSpan={3}>FPS</th>
                                <th colSpan={2 + allSchemes.length * 2}>Total Beneficiaries</th>
                                <th colSpan={2 + allSchemes.length * 2}>Updated Beneficiaries</th>
                                <th colSpan={2 + allSchemes.length * 2}>% Percentage of completion  </th>
                            </tr>
                            <tr className="tableheader">
                                {allSchemes.map((scheme) => (
                                    <th key={scheme} colSpan={2}>
                                        {scheme.toUpperCase()}
                                    </th>
                                ))}
                                <th colSpan={2}>Total</th>
                                {allSchemes.map((scheme) => (
                                    <th key={`${scheme}-ekyc`} colSpan={2}>
                                        {scheme.toUpperCase()}
                                    </th>
                                ))}
                                <th colSpan={2}>Total</th>
                                {allSchemes.map((scheme) => (
                                    <th key={`${scheme}-ekyc`} colSpan={2}>
                                        {scheme.toUpperCase()}
                                    </th>
                                ))}
                                <th colSpan={2}>Total</th>
                            </tr>
                            <tr className="tableheader">
                                {allSchemes.flatMap((scheme) => [<th key={`${scheme}-total-cards`}>Cards</th>, <th key={`${scheme}-total-units`}>Units</th>])}
                                <th >Cards</th>
                                <th >Units</th>
                                {allSchemes.flatMap((scheme) => [<th key={`${scheme}-ekyc-cards`}>Cards</th>, <th key={`${scheme}-ekyc-units`}>Units</th>])}
                                <th >Cards</th>
                                <th >Units</th>
                               {allSchemes.flatMap((scheme) => [<th key={`${scheme}-ekyc-cards`}>Cards</th>, <th key={`${scheme}-ekyc-units`}>Units</th>])}

                                <th >Cards</th>
                                <th >Units</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((row, index) =>
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{row.name}</td>
                                    {allSchemes.map((scheme) => {
                                        const s = row.total?.[scheme] || { cards: 0, units: 0 };
                                        return (
                                            <>
                                                <td align="right">{s.cards}</td>
                                                <td align="right">{s.units}</td>
                                            </>
                                        );
                                    })}

                <td align="right"   >{row.total_cards}</td>
                <td align="right">{row.total_units}</td>
                                    {allSchemes.map((scheme) => {
                                        const s = row.total?.[scheme] || { cards: 0, units: 0 };
                                        return (
                                            <>
                                                <td align="right">{s.cards}</td>
                                                <td align="right">{s.units}</td>
                                            </>
                                        );
                                    })}
                                    <td align="right">{row.total_cards}</td>
                                    <td align="right">{row.total_units}</td>
{allSchemes.map((scheme) => {
                  const s = row.ekyc?.[scheme];
                  const t = row.total?.[scheme];

                  return (
                    <>
                      <td align="right">
  {t.cards === 0 
    ? '0.00' 
    : (s.cards / t.cards * 100).toFixed(2)
  }
</td>
<td align="right">
  {t.units === 0 
    ? '0.00' 
    : (s.units / t.units * 100).toFixed(2)
  }
</td>
                    </>
                  );
                })}
                                    <td align="right">{((row.ekyc_cards / row.total_cards) * 100).toFixed(2)}</td>
                                    <td align="right">{((row.ekyc_units / row.total_units) * 100).toFixed(2)}</td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot>
                            <tr className="tableheader" >
                                <th colSpan={2}>Total</th>
                                {allSchemes.map((scheme) => (
                                    <>
                                        <td>{grandTotal[scheme]?.cards || 0}</td>
                                        <td>{grandTotal[scheme]?.units || 0}</td>
                                    </>
                                ))}
                                <td>{grandTotal_cards}</td>
                                <td>{grandTotal_units}</td>
                                {allSchemes.map((scheme) => (
                                    <>
                                        <td>{grandEkyc[scheme]?.cards || 0}</td>
                                        <td>{grandEkyc[scheme]?.units || 0}</td>
                                    </>
                                ))}
                                <td>{grandEkyc_cards}</td>
                                <td>{grandEkyc_units}</td>
                                 {allSchemes.map((scheme) => (
                <>
                  <td>{grandEkyc[scheme]?.cards === 0 ? "0.00" :Number((grandEkyc[scheme]?.cards /grandTotal[scheme]?.cards )*100).toFixed(2)}</td>
                  <td>{grandEkyc[scheme]?.units === 0 ? "0.00" :Number((grandEkyc[scheme]?.units /grandTotal[scheme]?.units )*100).toFixed(2)}</td>
                </>
              ))}
                                <td>{((grandEkyc_cards / grandTotal_cards) * 100).toFixed(2)}</td>
                                <td>{((grandEkyc_units / grandTotal_units) * 100).toFixed(2)}</td>
                            </tr>

                        </tfoot>
                    </table>
                </div>
            ) : (

                <div class="mainhead" align="center">
                    {message}
                </div>

            )}
            <br />
            <br /> 
            <br></br>
</div>
            {renderContent}
        </div>
    );
}

export default PortabilityFpsTable;
